import React, { Component } from 'react';
import ExpHelper from '../../../../Common/Helpers/ExpHelper';
import IngresoSolicitud from './IngresoSolicitud';

class Emision extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { data, selectCheckBox, selectCombo, selectRadio, changeInput, form, children } = this.props;
        let acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row bottom-separator">
                        <div className="col-xs-12">
                            <h2>{"Emisi" + acentoLetraOminuscula + "n"}</h2>
                        </div>
                    </div>

                    <IngresoSolicitud data={data} selectCheckBox={selectCheckBox} selectRadio={selectRadio} />
                    {children}

                </div>
            </div>
        );
    }
};

export default Emision;